import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const FindOnPageWrapper = styled.div`
  width: 100%;
  align-items: center;
  display: inline-flex;
`;

export const TopicErrorMsg = styled(Type)`
  line-height: 1.2;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.font.size.xs};
  }
`;
